import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { removeOrganization } from 'redux/modules/organization.js';
import * as styles from './Tab.scss';
import { connect } from 'react-redux';
var Tab = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  var _super = _createSuper(Tab);

  function Tab() {
    _classCallCheck(this, Tab);

    return _super.apply(this, arguments);
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          active = _this$props.active,
          title = _this$props.title,
          theme = _this$props.theme,
          width = _this$props.width;
      var tabStyle = {
        backgroundColor: theme.colors.gray4,
        borderColor: theme.colors.gray3,
        borderBottomColor: theme.colors.gray3,
        width: width
      };

      if (active) {
        tabStyle = {
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.gray3,
          borderBottomColor: 'white',
          width: width
        };
      }

      var closeButton = this.props.onClose ? /*#__PURE__*/React.createElement("span", {
        className: styles.closeBtn,
        onClick: function onClick() {
          return _this.props.onClose(_this.props.tabId);
        },
        style: {
          color: theme.colors.black5
        }
      }, "\xD7") : '';
      var innerTab = /*#__PURE__*/React.createElement("span", {
        title: title,
        className: styles.title,
        style: {
          color: theme.colors.black4
        }
      }, title);
      var tab = this.props.link ? /*#__PURE__*/React.createElement("div", {
        className: styles.tab,
        style: tabStyle
      }, /*#__PURE__*/React.createElement(Link, {
        to: this.props.link,
        key: this.props.tabId
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.tab,
        style: tabStyle
      }, innerTab)), closeButton) : /*#__PURE__*/React.createElement("div", {
        className: styles.tab,
        style: tabStyle
      }, innerTab, closeButton);
      return tab;
    }
  }]);

  return Tab;
}(Component), _defineProperty(_class2, "propTypes", {
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  width: PropTypes.string,
  onClose: PropTypes.func,
  tabId: PropTypes.string
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _defineProperty(_class2, "defaultProps", {
  width: '170px'
}), _defineProperty(_class2, "styleguide", {
  title: 'Tab',
  sample_code: '<Tab width="170px" />'
}), _temp)) || _class);
export default Tab;